export default __webpack_public_path__ + "static/media/silbato.657f9085.png";